import router, { resetRouter } from './index'
import type { RouteRecordRaw } from 'vue-router'
import nProgress from '@/utils/nProgress.js'
import * as util from '@/utils/utils'
import { useCurrentUser } from '@/hooks/user'
import { useTitle } from '@/utils/useTitle'
import { presetRoutes, rootRoute, constantRoutes, noPermissionRoute } from '@/router'
import { routerStoreWithOut } from '@/store/modules/router'
import { cloneDeep } from 'lodash-es'

function setAuthPathsToStorage(routes) {
  const user = useCurrentUser()
  const fullRoutes = [...constantRoutes, ...routes]
  const paths = util.getRoutePaths(fullRoutes)
  sessionStorage.setItem('auth-paths', paths.join())
  localStorage.setItem('auth-paths', paths.join())
  user.setAuthPaths(paths)
}

/**
 * @description 路由拦截开始
 * */
router.beforeEach(async (to, _form, next) => {
  const user = useCurrentUser()
  util.isShowMeg()
  // debugger;
  // 1.NProgress 开始
  nProgress.start()
  // next();
  if (user.info.token) {
    if (user.isGetMenu.value) {
      next()
    } else {
      try {
        await handleInitRoute()
        const routerStore = routerStoreWithOut()
        const addRoutes = routerStore.addRouters
        if (!addRoutes.length) {
          router.addRoute(noPermissionRoute)
          next({ name: 'noPermission' })
          return false
        }
      } catch (error) {
        user.isGetMenu.value = false
        next({ path: '/login', replace: true })
        console.error(error)
      }
      // next();

      next({ ...to, replace: true })
    }
  } else {
    if (to.path === '/login') {
      next()
    } else {
      next({ path: '/login' })
      nProgress.done()
    }
  }
})

/**
 * @description 获取第0个路由
 * @param {array} routes 路由数组
 */
const getDefaultIndexPath = routes => {
  if (routes && routes.length) {
    if (routes[0].children && routes[0].children.length) {
      return getDefaultIndexPath(routes[0].children)
    } else {
      return routes[0].path || '/auth' // 空白页?
    }
  } else {
    return '/auth'
  }
}

export async function handleInitRoute() {
  const user = useCurrentUser()
  const routerStore = routerStoreWithOut()
  // 生成动态路由
  const allRouters = await routerStore.generateRoutes()
  user.setAllMenu(allRouters)
  setAuthPathsToStorage(allRouters)
  resetRouter() // 重置静态路由表
  allRouters.forEach(route => {
    if (route.path && !route.path.startsWith('http')) {
      router.addRoute(route as unknown as RouteRecordRaw) // 动态添加可访问路由表
    }
  })
  console.log(router.getRoutes(), 'gerouter')
  // 因没有默认首页，调整首页'/'为权限路由第一个
  const menuList = util.getCurrentMenuList(presetRoutes, unref(user.authPaths))
  const defaultIndex = getDefaultIndexPath(menuList)
  const rootPath = defaultIndex
  const rootRouteClone = cloneDeep(rootRoute) 
  rootRouteClone.redirect = rootPath
  router.addRoute(rootRouteClone as unknown as RouteRecordRaw)
  user.isGetMenu.value = allRouters.length ? true : false
}

/**
 * @description 路由跳转结束
 * */
router.afterEach(to => {
  // const { path, name, query } = to
  // if (name !== 'login') {
  //   if (path) {
  //     // 记录当前访问的页面
  //     localStorage.setItem('current-page', path)
  //     localStorage.setItem('current-page-query', JSON.stringify(query))
  //   }
  // }
  useTitle(to?.meta?.title as string)
  nProgress.done()
})

/**
 * @description 路由跳转错误
 * */
router.onError(error => {
  nProgress.done()
  console.warn('路由错误', error.message)
})

export default router
